import { FullscreenOutlined } from "@ant-design/icons";
import { Button } from "antd";
import { useGetOfferQuery } from "api/TenantSlug/Offer/hooks";
import { SimpleCommissionsTableContainer } from "components/Tables/SimpleCommissionsTable/SimpleCommissionsTableContainer.tsx";
import { Drawer } from "components/UI/Drawer";
import { DrawerContent } from "components/UI/DrawerContent/DrawerContent.tsx";
import { DrawerTitle } from "components/UI/DrawerTitle/DrawerTitle.tsx";
import { usePaldockTranslation } from "hooks/usePaldockTranslation";
import { FC, useRef } from "react";
import { PermissionEnum } from "types/enums.ts";
import { DrawerId } from "types/models.ts";

interface OfferCommissionsOverviewDrawerProps {
    offerId: string;
}

export const OfferCommissionsOverviewDrawer: FC<OfferCommissionsOverviewDrawerProps> = ({ offerId }) => {
    const { t: tDrawer } = usePaldockTranslation("drawers.offer-commissions-overview");
    const { t } = usePaldockTranslation("common");
    const drawerId = DrawerId.OfferCommissionsOverview;
    const expandButtonRef = useRef<() => void>(null);

    const getOfferQuery = useGetOfferQuery(offerId, {
        filter: {
            include: "offerLinks,forms,formStructures,advertiser,userAffiliates,userRequests",
        },
    });
    const offer = getOfferQuery.data?.offer;

    if (!offer) {
        return null;
    }

    return (
        <Drawer
            drawerId={drawerId}
            title={<DrawerTitle mainTitle={tDrawer("title", { offerTitle: offer.title })} />}
            searchParamsToClean={[`${drawerId}-id`]}
            styles={{
                body: { padding: 0 },
            }}
            extraButtons={
                <Button
                    onClick={() => expandButtonRef.current?.()}
                    size="large"
                    icon={<FullscreenOutlined />}
                >
                    {t("expand")}
                </Button>
            }
        >
            <DrawerContent className={"m-[24px]"}>
                <div className={"p-[16px]"}>
                    <SimpleCommissionsTableContainer
                        offer={offer}
                        editPermission={PermissionEnum.AffiliateCommissionCurrentTierEdit}
                        expandButtonRef={expandButtonRef}
                    />
                </div>
            </DrawerContent>
        </Drawer>
    );
};
